import React from "react";
import TagList from "./components/TagList";
import "./index.less";

const TagsView = () => {
  return (
    <div className="tagsView-container">
      <TagList />
    </div>
  );
};

export default TagsView;
